<template>
  <div class="flex sharing-v">
    <Header />
    <secondStep titleMsg="选择考区" />
    <!-- <div class="flex tag-area sharing-h wrapper step-box">
      <span class="tag_word">
        <a-icon
          type="sound"
          style="font-size: 20px; margin-right: 2px; color: brown"
        />
        鉴于当前新冠肺炎疫情形势仍然严峻，根据上海国家会计学院疫情防控要求，经研究决定：仅上海作为全国唯一线下考点城市，其他地区考试形式调整为线上考试
      </span>
      <a-button type="link" class="tag_link">
        <a href="http://www.snai-rz.com/matif/4/711" target="_blank">
          查看详情<a-icon type="right" />
        </a>
      </a-button>
    </div> -->
    <div class="form-area">
      <div class="form-title">
        选择考点：
        <span style="color: #999">按首字拼音顺序排序</span>
      </div>
      <div
        class="flex sharing-h"
        style="justify-content: sapce-between; flex-wrap: wrap"
      >
        <a-tag
          class="city-tag"
          :color="areaName == item.areaName ? '#B01F21' : ''"
          @click="tagSelect(item)"
          v-for="item in placeList"
          :key="item.id"
          >{{ item.areaName }}</a-tag
        >
        <div class="tag-stead" v-for="item in 12" :key="item"></div>
      </div>
      <!-- 上传承若书 -->
      <div v-if="areaName == '线上考试'">
        <h5>
          请<a-button type="link" class="tag_link"
            ><a
              href="https://guanhuifileserver.oss-cn-shanghai.aliyuncs.com/ctm_commitment.pdf"
              target="_blank"
              >下载承诺书</a
            ></a-button
          >，签字后上传。
        </h5>
        <div class="clearfix">
          <a-spin :spinning="spinning">
            <a-upload
              name="avatar"
              accept="image/*"
              v-decorator="[
                'bookUrl',
                {
                  getValueFromEvent: normFile,

                  initialValue: bookUrl ? bookUrl : '',
                },
              ]"
              action="3131"
              :beforeUpload="beforeUpload"
              @change="backHandleChange"
              listType="picture-card"
              class="certificate-uploader"
              :showUploadList="false"
            >
              <img
                :src="
                  bookUrl ? bookUrl : require('@/assets/images/commitment.png')
                "
                alt="avatar"
              />
              <div class="btn-plus-book flex sharing-v" v-if="!bookUrl">
                <a-icon
                  :type="loading2 ? 'loading' : ''"
                  style="font-size: 24px; margin-bottom: 5px"
                />
                <!-- <div class="ant-upload-text">上传</div> -->
              </div>
            </a-upload>
          </a-spin>
        </div>
      </div>
      <div class="area-info flex sharing-v" v-if="areaName != '线上考试'">
        <p>
          您选择的考点是：
          <span>{{ areaName }}</span>
        </p>
        <p>
          请认真确认选择的考点，
          <span>报名时段结束后无法更改考点！</span>
        </p>
      </div>
    </div>
    <a-form-item class="text-center">
      <!-- <a href="/profile"
        ><a-button type="detault" inline-block style="margin-right: 20px"
          >上一步</a-button
        ></a
      > -->
      <a-button
        type="primary"
        @click="setExamPlace"
        inline-block
        class="login-form-button"
        >下一步</a-button
      >
    </a-form-item>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "../components/Header";
import secondStep from "../components/common/secondStep";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("apply");
export default {
  name: "Login",
  components: {
    Header,
    secondStep,
  },
  data() {
    return {
      checked: false,
      areaId: "",
      bookUrl: "",
      loading2: false,
      spinning: false,
      areaName: "",
      placeList: [],
      userInfo: {},
    };
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
    this.getExamPlace({
      examCode: userInfo.examCode,
    }).then((res) => {
      this.placeList = res.data.data;
    });
  },
  mounted() {
    // this.userInfo = JSON.parse(localStorage.getItem("studentInfo"));
    // this.areaId = this.userInfo.areaId ? this.userInfo.areaId : "";
    // this.areaName = this.userInfo.areaName ? this.userInfo.areaName : "";
    // console.log(this.userInfo)
    // this.bookUrl = this.userInfo.declareUrl ? this.userInfo.declareUrl : "";
    let userInfo = JSON.parse(localStorage.getItem("second_userInfo"));
    this.secondStuMsg({
      examCode: userInfo.examCode,
      userCode: userInfo.userCode,
    }).then((res) => {
      this.areaName = res.data.data.areaName ? res.data.data.areaName : "";
      this.areaId = res.data.data.areaId ? res.data.data.areaId : "";
      this.bookUrl = res.data.data.declareUrl ? res.data.data.declareUrl : "";
    });
  },
  methods: {
    ...mapActions([
      "getExamPlace",
      "updateAreaAction",
      "getPicUrl",
      "updateBookAction",
      "secondStuMsg"
    ]),
    normFile(e) {
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    beforeUpload(file) {
      //   const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      // if (!isJPG) {
      //   this.$message.error("文件格式为jpg、png!");
      // }
      // const isLt2M = file.size / 1024 < 500;
      // if (!isLt2M) {
      //   this.$message.error("图片大小不大于500kb!");
      // }
      // return isJPG && isLt2M;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$message.error("文件格式为jpg、png!");
      }
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error("图片大小不大于5M!");
      }
      return isJPG && isLt2M;
    },
    backHandleChange(info) {
      if (info.file.status === "uploading") {
        this.loading2 = true;
        this.spinning = true;
        return;
      } else {
        let formData = new FormData();
        formData.append("file", info.file.originFileObj);
        this.getPicUrl(formData).then((res) => {

          if (res.data.status == 2000) {
            this.bookUrl = res.data.data;
            this.spinning = false;
          }

        });
        // getBase64(info.file.originFileObj, imageUrl => {

        this.loading2 = false;
        // });
      }
    },
    tagSelect(area) {
      this.areaId = area.areaId;
      this.areaName = area.areaName;
    },
    setExamPlace() {
      if (this.areaName == "") {
        this.$warning({
          title: "注意",
          content: "考点不能为空",
          okText: "知道了",
          okType: "primary",
          maskClosable: true,
          onOk() { },
          onCancel() { },
        });
        return;
      }

      if (this.areaName == "线上考试" && (this.bookUrl == "" || this.bookUrl == null || this.bookUrl == "null")) {
        this.$warning({
          title: "注意",
          content: "请上传承诺书",
          okText: "知道了",
          okType: "primary",
          maskClosable: true,
          onOk() { },
          onCancel() { },
        });
        return;
      }
      let enrollInfo = JSON.parse(localStorage.getItem("second_userInfo"));
      enrollInfo.areaName = this.areaName
      enrollInfo.areaId = this.areaId
      if (this.areaName == "线上考试") {
        enrollInfo.declareUrl = this.bookUrl
      } else {
        enrollInfo.declareUrl = ""
      }
      console.log(enrollInfo)
      this.updateAreaAction(enrollInfo).then((res) => {
        this.applyStatusJudge(res.data);
      });
      // if (this.areaName!= "上海") {
      //   let values = {};
      //   let userInfo = JSON.parse(localStorage.getItem("studentInfo"));
      //   values.enrollInfoId = userInfo.enrollInfoId;
      //   values.examCode = userInfo.examCode;
      //   values.updateType = 3;
      //   values.areaName = this.areaName;
      //   values.areaId = this.areaId;

      //   let formData = new FormData();
      //   // fields 是表單內容，將它 append 到 formData
      //   Object.keys(values).map((item) => {
      //     formData.append(item, values[item]);
      //   });
      //   this.updateStudentAction(formData).then((res) => {
      //     this.applyStatusJudge(res.data);
      //   });
      // } else {
      //   let values = {};
      //   let userInfo = JSON.parse(localStorage.getItem("studentInfo"));
      //   // values.enrollInfoId = userInfo.enrollInfoId;
      //   values.examCode = userInfo.examCode;
      //   values.updateType = 3;
      //   values.areaName = this.areaName;
      //   values.areaId = this.areaId;
      //   values.url = this.bookUrl;
      //   let formData = new FormData();
      //   // fields 是表單內容，將它 append 到 formData
      //   Object.keys(values).map((item) => {
      //     formData.append(item, values[item]);
      //   });
      //   this.updateBookAction(formData).then((res) => {
      //     this.applyStatusJudge(res.data);
      //   });
      // }
    },
    // 提交带承诺书的表单

    applyStatusJudge(data) {
      if (data.status == 2000) {
        this.$router.push("/secondInfomation");
      } else {
        this.$warning({
          title: data.message,
          content: data.message,
          okText: "知道了",
          okType: "primary",
          maskClosable: true,
          onOk() { },
          onCancel() { },
        });
      }
    },
  },
};
</script>

<style scoped>
.row-item {
  margin-top: 15px;
}
.form-title {
  margin-bottom: 15px;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}

.city-tag {
  width: 92px;
  height: 32px;
  margin-bottom: 15px;
  line-height: 32px;
  text-align: center;
  background: rgba(238, 238, 238, 1);
  border-radius: 4px;
}
.area-info {
  margin-top: 30px;
  padding: 30px 25px;
  align-items: flex-start;
  background: #f9f9f9;
}
.area-info span {
  color: #b01f21;
}
.tag-stead {
  width: 92px;
}
.tag-area {
  padding: 5px 0;
  padding-left: 15px;
  justify-content: sapce-between;
  align-items: center;
  height: auto;
  background: #f7e8e8;
  border-radius: 4px;
  border: 1px solid rgba(213, 29, 32, 0.3);
}

.tag_link {
  display: inline-block;
  color: #0075ff;
}
.clearfix {
  width: 343px;
}
.btn-plus-book {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 88px;
  height: 88px;
  margin-left: -44px;
  margin-top: -44px;
  /* color: #fff; */
  /* background: rgba(51, 51, 51, 0.3); */
  /* -webkit-box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.11);
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.11); */
  /* border-radius: 44px; */
}
</style>